import Clock from '../Clock';
import beep2000Hz from './beep-2000Hz.wav';

import ReactAudioPlayer from 'react-audio-player';
import React, { Component, Fragment } from 'react';
import { pick } from 'lodash';

class TimingClock extends Component {
  state = { timeRemaining: null };
  tickTimeout = null;

  computeTimeRemaining() {
    const { time, timeStarted, timePassed } = this.props;

    const timePassedNow = timeStarted ? Date.now() - timeStarted : 0;
    return Math.max(time - timePassed - timePassedNow, 0);
  }

  tick = () => {
    const { timeStarted } = this.props;
    const timeRemaining = this.computeTimeRemaining();
    const nextSecond = Math.floor(timeRemaining / 1000);
    const untilNextSecond = Math.max(timeRemaining - nextSecond * 1000, 0);

    if (this.tickTimeout) window.clearTimeout(this.tickTimeout);

    this.tickTimeout =
      timeStarted && timeRemaining
        ? window.setTimeout(this.tick, untilNextSecond)
        : null;

    this.setState({ timeRemaining });
  };

  untick = () => {
    if (this.tickTimeout) window.clearInterval(this.tickTimeout);
  };

  componentDidMount() {
    const { timeStarted } = this.props;

    if (timeStarted) this.tick();
  }

  componentDidUpdate(prevProps) {
    const { timeStarted } = this.props;
    if (timeStarted && !prevProps.timeStarted) this.tick();
  }

  componentWillUnmount() {
    this.untick();
  }

  render() {
    const { timeStarted, mute } = this.props;
    const timeRemaining = this.computeTimeRemaining();
    const secondsRemaining = Math.floor(timeRemaining / 1000);
    const clock = {
      minutes: Math.floor(secondsRemaining / 60),
      seconds: secondsRemaining % 60,
      ...pick(this.props, 'size'),
    };

    const beep =
      !mute && !!timeStarted &&
      (secondsRemaining === 0 ||
        secondsRemaining === 30 ||
        secondsRemaining === 90);

    return (
      <Fragment>
        <Clock {...clock} />
        {beep && <ReactAudioPlayer src={beep2000Hz} autoPlay />}
      </Fragment>
    );
  }
}

export default TimingClock;



// WEBPACK FOOTER //
// ./src/components/TimingClock/TimingClock.js